import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import '@/i18n'
import '@/styles/global.css'

/** 与 `pages/Launch` 中 `takeLaunchReturnPath` 使用的 key 一致 */
const LAUNCH_RETURN_KEY = 'mx_launch_return'

function redirectToLaunchOnDocumentLoad(): void {
  const path = window.location.pathname
  if (path === '/launch') {
    return
  }
  const nav = performance.getEntriesByType('navigation')[0] as
    | PerformanceNavigationTiming
    | undefined
  if (!nav || (nav.type !== 'reload' && nav.type !== 'navigate')) {
    return
  }
  sessionStorage.setItem(
    LAUNCH_RETURN_KEY,
    `${window.location.pathname}${window.location.search}${window.location.hash}`,
  )
  window.history.replaceState(null, '', '/launch')
}

/**
 * `createBrowserRouter` 在模块执行时读取 `window.location`。
 * 必须先 replace 到 `/launch` 再加载 router 模块，否则首次刷新会停在错误路由，Lottie 不执行。
 */
function bootstrap(): void {
  redirectToLaunchOnDocumentLoad()
  void import('@/router').then(({ default: router }) => {
    createRoot(document.getElementById('root')!).render(
      <RouterProvider router={router} />,
    )
  })
}

bootstrap()
